import React from 'react';
import { Search } from 'lucide-react';
import type { CableSourceFilter } from '../../utils/cables.logic';

interface CablesFilterProps {
  search: string;
  setSearch: (val: string) => void;
  typeFilter: string;
  setTypeFilter: (val: string) => void;
  statusFilter: string;
  setStatusFilter: (val: string) => void;
  sourceFilter: CableSourceFilter;
  setSourceFilter: (val: CableSourceFilter) => void;
  cableTypes: string[];
}

export const CablesFilter: React.FC<CablesFilterProps> = ({
  search, setSearch,
  typeFilter, setTypeFilter,
  statusFilter, setStatusFilter,
  sourceFilter, setSourceFilter,
  cableTypes
}) => {
  return (
    <div className="flex flex-col md:flex-row gap-4 justify-between items-center bg-slate-900/40 backdrop-blur-md border border-slate-800/50 p-4 rounded-sm shadow-sm">
      {/* Search */}
      <div className="relative w-full md:w-80">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
        <input
          type="text"
          placeholder="Поиск по устройству или ID..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="w-full pl-9 pr-4 py-2 bg-slate-900/40 border border-slate-800/50 rounded-sm text-sm text-text-primary focus:border-accent outline-none transition-colors"
        />
      </div>

      {/* Filters */}
      <div className="flex flex-wrap gap-3 w-full md:w-auto">
        <select
          data-testid="filter-cable-source"
          value={sourceFilter}
          onChange={e => setSourceFilter(e.target.value as CableSourceFilter)}
          className="px-3 py-2 bg-slate-900/40 border border-slate-800/50 rounded-sm text-sm text-text-primary focus:border-accent outline-none cursor-pointer transition-colors"
        >
          <option value="all" className="bg-slate-900 text-text-primary">Все источники</option>
          <option value="netbox" className="bg-slate-900 text-text-primary">Только NetBox</option>
          <option value="manual" className="bg-slate-900 text-text-primary">Только Ручные</option>
        </select>

        <select
          value={typeFilter}
          onChange={e => setTypeFilter(e.target.value)}
          className="px-3 py-2 bg-slate-900/40 border border-slate-800/50 rounded-sm text-sm text-text-primary focus:border-accent outline-none cursor-pointer transition-colors"
        >
          <option value="all" className="bg-slate-900 text-text-primary">Все типы кабелей</option>
          {cableTypes.map(t => (
            <option key={t} value={t} className="bg-slate-900 text-text-primary">{t}</option>
          ))}
        </select>

        <select
          value={statusFilter}
          onChange={e => setStatusFilter(e.target.value)}
          className="px-3 py-2 bg-slate-900/40 border border-slate-800/50 rounded-sm text-sm text-text-primary focus:border-accent outline-none cursor-pointer transition-colors"
        >
          <option value="all" className="bg-slate-900 text-text-primary">Все статусы</option>
          <option value="live" className="bg-slate-900 text-text-primary">Live (Активные)</option>
          <option value="planned" className="bg-slate-900 text-text-primary">Planned (Планируемые)</option>
          <option value="faulted" className="bg-slate-900 text-text-primary">Faulted (Сбойные)</option>
        </select>
      </div>
    </div>
  );
};
